import React from 'react';

const Hero = () => {
  return (
    <section
      id="home"
      className="relative bg-cover bg-center h-screen flex items-center justify-center text-white"
      style={{ backgroundImage: "url('/assets/hero-bg.jpg')" }}
    >
      <div className="absolute inset-0 bg-black opacity-50"></div>

      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-bold mb-4">
          Luxury Accommodation <br className="hidden md:block" /> in Ntchisi
        </h1>
        <p className="text-2xl md:text-3xl mb-6">Welcome to Tuneza Lodge</p>
        <p className="text-lg md:text-xl mb-10 max-w-2xl mx-auto">
          Experience world‑class hospitality in the tranquil heart of Ntchisi. 
          Luxurious rooms, modern conferencing, and unforgettable nature.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#rooms"
            className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-md text-lg font-semibold hover:bg-white hover:text-gold-600 transition"
          >
            View Rooms
          </a>
          <a
            href="#contact"
            className="bg-gold-500 hover:bg-gold-600 text-white px-8 py-3 rounded-md text-lg font-semibold transition"
          >
            Book Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;